<template>
  <div>
    <auto-form :fields="fields" :item="item"></auto-form>
    <v-data-table :items="item.employeeReviewDetails" :headers="viewHeaders">
      <template v-slot:item.score="{ item }">
        <v-icon v-if="item.score" color="green">mdi-check</v-icon>
        <v-icon v-if="!item.score" color="red">mdi-close</v-icon>
      </template>
      
      <template v-slot:item.conditionTitle="{ item }">
        <b >{{ item.conditionTitle }}</b>
        <p class="text--body-2">
          {{ item.conditionBody }}
        </p>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import AutoForm from '../../../../components/CommonView/AutoForm.vue';
import * as moment from "moment/moment";
import {view } from './header'
export default {
  props: {
    item: {
      type: Object
    },
  },
  components: {
    AutoForm
  },
  computed: {
    fields () {
      return [
        {name: 'id', label:'Id', type: 'text-field', value: this.item?.id, cols: 12 },
        {name: 'employeeCode', label:'Mã nhân viên', type: 'text-field', value: this.item?.employeeCode, cols: 12, md:6 },
        {name: 'employeeName', label:'Tên nhân viên', type: 'text-field', value: this.item?.employeeName, cols: 12, md:6 },
        {name: 'validFrom', label:'Bắt đầu', type: 'text-field', isDate: true, value: this.$formatter.formatDate(this.item?.validFrom, 'YYYY-MM-DD'), cols: 12, md:6 },
        {name: 'validTo', label:'Kết thúc', type: 'text-field', isDate: true, value: this.$formatter.formatDate(this.item?.validTo, 'YYYY-MM-DD'), cols: 12, md:6 },
        {name: 'score', label:'Đánh giá', type: 'text-field', value: `${this.item?.score ?? 0}/${this.item?.maxScore}`, cols: 12, md:6 },
        // {name: 'comments', label:'Bình luận', type: 'text-field', value: this.item?.comments, cols: 12, md:12 },
      ]
    },
    
    viewHeaders () {
      return view([])
    }
  },
  data() {
    return {
    }
  },
  methods: {

  }

}
</script>